import { render, staticRenderFns } from "./RadioView.vue?vue&type=template&id=741963d8&scoped=true"
import script from "./RadioView.vue?vue&type=script&lang=js"
export * from "./RadioView.vue?vue&type=script&lang=js"
import style0 from "./RadioView.vue?vue&type=style&index=0&id=741963d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741963d8",
  null
  
)

export default component.exports